export { default } from './ContactsPage';
export { default as NewContact } from './NewContact';
export { default as ViewContact } from './ViewContact';
export { default as ModifyContact } from './ModifyContact';
export { default as EditPassword } from './EditPassword';
